import React, { useState, useEffect } from "react";
import Header from "../../../Componets/Header";
import DocumentGrid from "../../../Componets/DocumentGrid";
import DocumentUpload from "../Form";
import Loadercomponent from "../../../Componets/Loader";
import { Button, Input, Select, Space } from "antd";
import {
  UploadOutlined,
  ReloadOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  uploadDocument,
  getDocuments,
  deleteDocument,
  downloadDocument,
  viewDocument,
} from "../../../Controllers/DocumentVolt";
import toast from "react-hot-toast";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const DocumentVault = () => {
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [fileType, setFileType] = useState("");
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
    pageSize: 20,
  });

  const headers = {
    name: "Document Vault",
    components: [],
    navigate: {
      tabs: [
        {
          name: "Document Vault",
          path: "/app/documents",
        },
      ],
    },
  };

  const fetchDocuments = async (page = 1) => {
    try {
      setLoading(true);
      const response = await getDocuments({
        search: search || undefined,
        fileType: fileType || undefined,
        page,
        limit: pagination.pageSize,
      });

      if (response.status) {
        setDocuments(response.data.data);
        setPagination({
          currentPage: response.data.currentPage,
          totalCount: response.data.totalCount,
          totalPages: response.data.totalPages,
          pageSize: pagination.pageSize,
        });
      } else {
        toast.error(response.message || "Failed to fetch documents");
      }
    } catch (error) {
      toast.error("Error fetching documents");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [search, fileType]);

  const handleUpload = async (formData) => {
    try {
      const response = await uploadDocument(formData);
      if (response.status) {
        toast.success("Document uploaded successfully");
        fetchDocuments(pagination.currentPage);
        setUploadModalOpen(false);
      } else {
        toast.error(response.message || "Upload failed");
      }
    } catch (error) {
      toast.error("Error uploading document");
      console.error(error);
    }
  };

  const handleDelete = async (documentId) => {
    try {
      const response = await deleteDocument({ id: documentId });
      if (response.status) {
        toast.success("Document deleted successfully");
        fetchDocuments(pagination.currentPage);
      } else {
        toast.error(response.message || "Delete failed");
      }
    } catch (error) {
      toast.error("Error deleting document");
      console.error(error);
    }
  };

  const handleDownload = async (documentId) => {
    try {
      const token = localStorage.getItem("user");

      const response = await axios.get(
        `${APIURL}/view-document/${documentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        },
      );

      const fileURL = URL.createObjectURL(response.data);
      window.open(fileURL, "_blank");
    } catch (error) {
      console.error(error);
      toast.error("Unable to download document");
    }
  };

  const formdata = (data) => {
    setSearch(data.search || "");
  };

  const fileTypeOptions = [
    { label: "All Types", value: "" },
    { label: "PDF", value: "pdf" },
    { label: "Word", value: "docx" },
    { label: "Excel", value: "excel" },
    { label: "CSV", value: "csv" },
    { label: "Images", value: "image" },
  ];

  return (
    <Header headers={headers} formdata={formdata}>
      <Loadercomponent loader={loading}>
        <div>
          <div className="flex justify-between items-center mb-4 mt-4">
            <div className="flex items-center space-x-2"></div>
            <div className="flex items-center space-x-2">
              <Button
                icon={<ReloadOutlined />}
                onClick={() => fetchDocuments(pagination.currentPage)}
                disabled={loading}
              >
                Refresh
              </Button>
              <Button
                type="primary"
                icon={<UploadOutlined />}
                onClick={() => setUploadModalOpen(true)}
              >
                Upload Document
              </Button>
            </div>
          </div>

          <DocumentGrid
            documents={documents}
            loading={loading}
            pagination={pagination}
            onPageChange={(page) => fetchDocuments(page)}
            onDelete={handleDelete}
            onDownload={handleDownload}
            onRefresh={() => fetchDocuments(pagination.currentPage)}
          />

          <DocumentUpload
            open={uploadModalOpen}
            onClose={() => setUploadModalOpen(false)}
            onUpload={handleUpload}
            loading={loading}
          />
        </div>
      </Loadercomponent>
    </Header>
  );
};

export default DocumentVault;
